import React from "react"
import type { Transaction } from "@digits-graphql/frontend/graphql-bearer"
import { CellText } from "@digits-shared/DesignSystem/Tables/tableStyles"

export const ReferenceNumberCell: React.FC<{ transaction: Transaction }> = ({ transaction }) => (
  <CellText>{transaction.referenceNumber}</CellText>
)
